import layout from '../layout'
export default function makeUserPaidRoutes({
  contentType,
  components: { UserPaidListingContainer }
}) {

  return [
    {
      path: '/',
      component: layout,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: `/subscribed-users/list/`,
          component: UserPaidListingContainer,
          props: {
            contentType,
          }
        },
      ]
    },
  ];
}
